import { FormControl, Validators } from '@angular/forms';


export class FormControlHelpers{

static setRequired(control: FormControl): void {
  control.setValidators([Validators.required]);
  control.updateValueAndValidity();
}

static clearValidators(control: FormControl): void {
  control.setValidators([]);
  control.updateValueAndValidity();
}

}